<template lang="pug">
	#login.admin.theme-1
		section.material-half-bg
			.cover

		section.login-content
			.logo: h1 

			.login-box
				ValidationObserver(ref="ValidatorLogin")
					form.login-form(@submit.prevent='onSubmit')
						h3.login-head
							i.fa.fa-lg.fa-fw.fa-user
							| RESET PASSWORD
						.form-group
							label.control-label NEW PASSWORD
							ValidationProvider(name="New Password" v-slot='{errors}' rules='required|min:8')
								input.form-control(type="password" autofocus v-model='form.new_pass')
								//- template(v-if='errors.length')
								small.text-danger(v-for='error in errors') {{error}}

						.form-group
							label.control-label CONFIRM PASSWORD
							ValidationProvider(name="Confirm Password" v-slot='{errors}' v-bind:rules='`required|is:${form.new_pass}`')
								input.form-control(type="password" v-model='form.confirm_pass')
								small.text-danger(v-for='error in errors') {{error}}

						//- .form-group
							.utility
								.animated-checkbox
									label
										input(type="checkbox")
										span.label-text Stay Signed in
								p.semibold-text.mb-2
									a(href="#" data-toggle="flip") Forgot Password?

						.form-group.btn-container.text-center
							button.btn.btn-primary.btn-block(type='submit')
								i.fas.fa-sign-in-alt.fa-fw
								| &nbsp;CHANGE PASSWORD
							br
							a(href='javascript:void(0);' @click.prevent='$router.push("/")'): b Already a Member? Click here
							//- button.btn.btn-primary.btn-block
								i.fas.fa-sign-in-alt.fa-fw
								| &nbsp;SIGN IN
				//- form.forget-form(@submit.prevent="resetPassword")
					h3.login-head
						i.fa.fa-lock
						| &nbsp;Forgot Password ?
					.form-group
						label.control-label EMAIL
						input.form-control(type="text", placeholder="Email" v-model='resetEmail')

					.form-group.btn-container
						button.btn.btn-primary.btn-block
							i.fa.fa-unlock.fa-lg.fa-fw
							| RESET

					.form-group.mt-3
						p.semibold-text.mb-0
							a(href="#" data-toggle="flip") <i class="fa fa-angle-left fa-fw"></i> Back to Login
</template>

<script>
import $ from 'jquery'


export default {

	name: 'reset-password',

	components: {
	},

	data () {
		return {
			form: {
				new_pass: '',
				confirm_pass: '',
			}
		}
	},
	mounted(){
		/*$('.login-content [data-toggle="flip"]').click(function() {
			$('.login-box').toggleClass('flipped');
			return false;
		});*/
	},

	methods: {
		onSubmit() {
			this.$refs.ValidatorLogin.validate()
				.then( success => {
					// console.log('success', success)

					if(!success) {
						return;
					}

					this.$swal({
						text: 'Authenticating. . .'
					})
					this.$swal.showLoading()
					this.$http.put('web/reset-password/'+this.$route.params.token, this.form).then( response => {
						// console.log(response)
						// this.$store.commit('user/setInfo', response.data.user)
						// this.$store.commit('user/setToken', response.data)
						const self=this
						this.$swal({
							icon: 'success',
							title: 'Success!',
							text:'Password was successfuly reseted!',
							onClose(){
								self.$router.replace('/')
							}
						})
					}).catch( response => {
						// console.log(response)
						this.$swal({
							icon: 'error',
							text: 'Invalid Credentials'
						})
					}).finally(() => {
						// this.$swal.hideLoading()
					})
				})
		}
	}
}
</script>

<style lang="scss" scoped>
	.login-box {
		min-width: 375px !important;
		min-height: 400px !important;
	}
</style>